
'use client';

import Link from 'next/link';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { MoreHorizontal, PlusCircle, HandHeart } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '@/context/AuthContext';
import { useFriend } from '@/context/FriendContext';
import { EditFriendDialog } from './edit-friend-dialog';
import { Skeleton } from './ui/skeleton';
import { Separator } from './ui/separator';

export function RightSidebar() {
  const { isOwner } = useAuth();
  const { friends, loading } = useFriend();

  return (
    <div className="p-4 space-y-6">
      <div>
        <div className="flex justify-between items-center mb-2 px-2">
            <h3 className="text-sm font-semibold text-muted-foreground">
              ARTIST FRIENDS
            </h3>
            <div className="flex gap-2 text-muted-foreground">
                {isOwner && (
                  <EditFriendDialog>
                    <Button variant="ghost" size="icon" className="h-8 w-8">
                      <PlusCircle className="h-5 w-5"/>
                    </Button>
                  </EditFriendDialog>
                )}
                <Button variant="ghost" size="icon" className="h-8 w-8">
                    <MoreHorizontal className="h-5 w-5"/>
                </Button>
            </div>
        </div>
        <ul className="space-y-2">
          {loading ? (
             Array.from({ length: 5 }).map((_, i) => (
                <li key={i} className="flex items-center gap-3 p-2">
                    <Skeleton className="h-8 w-8 rounded-full" />
                    <Skeleton className="h-4 w-2/3" />
                </li>
            ))
          ) : (
            friends.map((friend) => (
              <li key={friend.id}>
                <Link
                  href={`/friends/${friend.id}`}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-secondary transition-colors"
                >
                  <div className="relative">
                    <Avatar className="h-8 w-8">
                      <AvatarImage src={friend.avatarUrl} alt={friend.name} />
                      <AvatarFallback>{friend.name.substring(0, 2)}</AvatarFallback>
                    </Avatar>
                    <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-green-500 ring-2 ring-card" />
                  </div>
                  <span className="font-semibold">{friend.name}</span>
                </Link>
              </li>
            ))
          )}
        </ul>
      </div>

      <Separator />

      <div>
        <div className="flex justify-between items-center mb-2 px-2">
            <h3 className="text-sm font-semibold text-muted-foreground">
              ARTISTS SUPPORT ARTIST
            </h3>
        </div>
        <div className="px-2">
            <Link href="/support" passHref>
                <Button variant="outline" className="w-full">
                    <HandHeart className="mr-2 h-4 w-4"/>
                    Go to Page
                </Button>
            </Link>
        </div>
      </div>
    </div>
  );
}
